// extracted by mini-css-extract-plugin
export default {"initializingSpinner":"InitializingSpinner_initializingSpinner__AK66c","text":"InitializingSpinner_text__FZXPo"};